export * from './analytics-utils';
export * from './cartinfo-cookie';
export * from './classnames';
export * from './device-detect';
export * from './is-bot';
export * from './join-classes';
export * from './locale';
export * from './numbers';
export * from './parse-float-value';
export * from './range';
export * from './string-is-number';
export { addSlashToEndOfUrl } from './url';
export { extractIdFromPathname } from './extract-id-from-pathname';
export { getDatePlusYear } from './date-time-helpers';
export { getDomain } from './get-domain';
export { getLang } from './get-lang';
export { initI18n } from './init-i18n';
export { patchUrlByLocale } from './patch-url-by-locale';
export { transliterate } from './transliterate';
export { getBrandLink } from './get-brand-link';
export { getDayMonthAfterTomorrowString } from './get-day-month-string';

export const deserializeAEMCookieCollection =
  <T>(deserializeItem: (item: string) => T, splitter = ';') =>
  (cookieValue = ''): T[] => {
    const result: T[] = [];
    if (cookieValue.trim().length > 0) {
      const chunks = decodeURIComponent(cookieValue).split(splitter);
      if (chunks.length > 0) {
        result.push(...chunks.map(deserializeItem));
      }
    }

    return result;
  };

export const serializeAEMCookieCollection =
  <T>(serializeItem: (item: T) => string, splitter = ';') =>
  (itemsCollection: T[] = []): string => {
    const result: string = encodeURIComponent(itemsCollection.map(serializeItem).join(splitter));
    return result;
  };
